
import { useEffect, useState } from "react";
import CollectionGrid from "@/components/dashboard/CollectionGrid";
import { INBOX_ID } from "@/utils/contentFormUtils";
import EditContentDialog from "@/components/dashboard/EditContentDialog";
import { usePersistentViewMode } from "@/hooks/usePersistentViewMode";
import { useCollections } from "@/contexts/collections";
import { useMetadata } from "@/hooks/useMetadata";

const InBox = () => {
  const [selectedContentId, setSelectedContentId] = useState<string | null>(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState("");
  const { viewMode, setViewMode } = usePersistentViewMode();
  const { refreshCollections } = useCollections();
  
  // Apply metadata for this page
  useMetadata({
    title: "Clustr In Box - Your unorganized content",
    description: "Content not yet organized into collections. Process your inbox regularly to keep your digital library organized.",
    image: "/lovable-uploads/f2a45c76-e26b-4dda-b84d-a3d97e47ee35.png"
  });
  
  // Force collection refresh on every mount and when route changes
  useEffect(() => {
    console.log("[InBox] Component mounted, refreshing collections");
    refreshCollections();
    
    // Also refresh when the page becomes visible (user switches back to tab)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log("[InBox] Page became visible, refreshing collections");
        refreshCollections();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refreshCollections]);

  const handleEditContent = (contentId: string, title: string) => {
    setSelectedContentId(contentId);
    setCurrentTitle(title);
    setEditDialogOpen(true);
  };

  const inboxDescription = "Content not yet organized into collections";

  return (
    <div className="flex-1 flex flex-col h-full">
      <main className="flex-1 overflow-y-auto h-full">
        <CollectionGrid 
          title="In Box"
          description={inboxDescription}
          collectionId={INBOX_ID}
          collectionColor="#6B7789"
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          onEditContent={handleEditContent}
        />
        
        {selectedContentId && (
          <EditContentDialog
            contentId={selectedContentId}
            title={currentTitle}
            isOpen={editDialogOpen}
            onOpenChange={setEditDialogOpen}
          />
        )}
      </main>
    </div>
  );
};

export default InBox;
